import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon, type IconName } from '@/components/foundations';
import { InfoHint } from '@/components/feedback/InfoHint';
import { Ring } from '@/components/charts/Ring';

export type StatTrend = { dir: 'up' | 'down'; value: ReactNode; text?: ReactNode };

export type StatCardProps = {
  icon: IconName;
  label: ReactNode;
  value: ReactNode;
  /** Ícone ⓘ depois do rótulo; string = texto da dica. */
  info?: boolean | string;
  /** Variação em destaque: "▲ 12,4% vs mês anterior". */
  trend?: StatTrend;
  /** Linha de apoio (`.d`). */
  hint?: ReactNode;
  /** Link no lugar da linha de apoio (ex.: "Ver detalhes"). */
  link?: { to: string; label: ReactNode };
  /** Selo acima do rótulo (status da fatura). */
  badge?: ReactNode;
  /** Fatura aberta (`bill open`). Com `badge`, o cartão vira `bill`. */
  highlight?: boolean;
  valueClassName?: string;
};

/** Indicador com ícone no anel (`.card.stat`). */
export function StatCard({ icon, label, value, info = true, trend, hint, link, badge, highlight, valueClassName }: StatCardProps) {
  const cls = ['card stat', badge !== undefined ? 'bill' : '', highlight ? 'open' : ''].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <Ring icon={icon} />
      <div>
        {badge}
        <div className="l" style={badge !== undefined ? { marginTop: 8 } : undefined}>
          {label}
          {info && <> <InfoHint content={typeof info === 'string' ? info : undefined} /></>}
        </div>
        <div className={valueClassName === undefined ? 'v' : `v ${valueClassName}`}>{value}</div>
        {trend && (
          <div className="d"><b><Icon name={trend.dir === 'up' ? 'up' : 'dn'} />{trend.value}</b>{trend.text && <> {trend.text}</>}</div>
        )}
        {hint !== undefined && <div className="d">{hint}</div>}
        {link && <Link className="link" to={link.to}>{link.label} <Icon name="chev" /></Link>}
      </div>
    </div>
  );
}
